module.exports = __webpack_public_path__ + "img/sync-off-green.03bf4bbd.svg";